var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Codable } from '@1amageek/ballcap';
import { Base } from '.';
import { MasterText, MasterValue } from '../common/entity';
export class Master extends Base {
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('master');
    }
}
Master.documentId = 'v1';
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "prefectureList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "rewardTypeList", void 0);
__decorate([
    Codable(MasterValue),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "rewardOfHourList", void 0);
__decorate([
    Codable(MasterValue),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "rewardOfDayList", void 0);
__decorate([
    Codable(MasterValue),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "rewardOfMonthlyList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "paymentList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "requirementList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "employmentList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "medicalDepartmentList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "occupationList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "qualificationList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "identificationList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "facilityList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "contractPlanList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "genderList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "clinicalExperienceList", void 0);
__decorate([
    Codable(MasterText),
    Field,
    __metadata("design:type", Array)
], Master.prototype, "jobDescriptionTemplateList", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], Master.prototype, "jobTemplateImages", void 0);
